import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import BreadcrumbComp from "../CommonComponents/Breadcrumb/Breadcrumb";
import Datatable from "../CommonComponents/Datatable/Datatable";
import { AuditReportListData } from "../../helpers/renderData";
import { Button } from "reactstrap";

const auditLogs = [
  {
    date: "2025-07-17",
    time: "10:30 AM",
    user: "Riya Sharma",
    role: "Admin",
    activity: "Login",
    details: "User successfully logged in.",
  },
  {
    date: "2025-07-17",
    time: "11:15 AM",
    user: "Amit Patel",
    role: "Employee",
    activity: "Updated Lead",
    details: "Changed lead status from New to Interested.",
  },
  {
    date: "2025-07-16",
    time: "03:45 PM",
    user: "Nikita Shah",
    role: "Admin",
    activity: "Viewed Document",
    details: "Viewed Agreement.pdf file.",
  },
  {
    date: "2025-07-15",
    time: "01:20 PM",
    user: "Raj Patel",
    role: "Employee",
    activity: "Deleted Task",
    details: "Deleted follow-up reminder for Client ID #9823.",
  },
];

const AuditReportList = () => {
  const [tableData, setTableData] = useState({});
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isFiltered, setIsFiltered] = useState(false);

  const itemArray = () => [
    {
      name: "Audit Report",
      active: true,
      link: "",
    },
  ];

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async (filtered = false) => {
    let dataToUse = auditLogs;

    if (filtered && fromDate && toDate) {
      dataToUse = auditLogs.filter((log) => {
        return log.date >= fromDate && log.date <= toDate;
      });
    }
    const data = await AuditReportListData(dataToUse, {});
    setTableData(data);
  };

  const handleFilter = () => {
    if (fromDate && toDate) {
      setIsFiltered(true);
      loadData(true);
    }
  };

  const handleReset = () => {
    setFromDate("");
    setToDate("");
    setIsFiltered(false);
    loadData(false);
  };

  return (
    <div>
      {/* Breadcrumb */}
      <Grid item lg={12} sm={12} xs={12} md={12}>
        <BreadcrumbComp items={itemArray()} />
      </Grid>
      
      {/* Date Filter */}
      <Stack direction="row" spacing={2} alignItems="end" mt={3}>
        <Box>
          <Typography fontSize="14px" fontWeight={500} mb={0.5}>
            From
          </Typography>
          <TextField
            type="date"
            size="small"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            sx={{ width: 230 }}
          />
        </Box>

        <Box>
          <Typography fontSize="14px" fontWeight={500} mb={0.5}>
            To
          </Typography>
          <TextField
            type="date"
            size="small"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            sx={{ width: 230 }}
          />
        </Box>

        <Button
          onClick={handleFilter}
          style={{
            height: "40px",
            backgroundColor: "var(--thm-color)",
            textTransform: "none",
            fontWeight: 500,
            width: 100,
          }}
        >
          Filter
        </Button>

        {isFiltered && (
          <Button
            onClick={handleReset}
            style={{
              height: "40px",
              backgroundColor: "var(--thm-color)",
              textTransform: "none",
              fontWeight: 500,
              width: 100,
            }}
          >
            Reset
          </Button>
        )}
      </Stack>

      {/* DataTable */}
      <Grid container className="data-table-main" style={{ marginTop: "8px" }}>
        <Grid item lg={12} sm={12} md={12} xs={12}>
          <div className="card-main" style={{ width: "100%" }}>
            <Datatable props={tableData} title="Audit Report" />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default AuditReportList;
